import { render } from "./FuturesBalanceDeltaActionGraphWidgetParams.vue?vue&type=template&id=58282791"
import script from "./FuturesBalanceDeltaActionGraphWidgetParams.vue?vue&type=script&lang=js"
export * from "./FuturesBalanceDeltaActionGraphWidgetParams.vue?vue&type=script&lang=js"
script.render = render

export default script